<template>
<material-card icon="mdi-bus-multiple" inline title="Vehicle Settings">
  <v-container fluid>
    <v-row>
      <v-col class="my-0 py-0" cols="13" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleDetails' }" title="Vehicle Details">
          <clickable-card  icon="mdi-bus" color="warning" cardTitle="Vehicle Details  "> </clickable-card>
        </router-link>
      </v-col>
      <v-col class="my-0 py-0" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleInsurance' }" title="Vehicle Insurance Details">
          <clickable-card  icon="mdi-credit-card-outline" color="pink" cardTitle="Vehicle Insurance"> </clickable-card>
        </router-link>
      </v-col>
      <v-col class="my-0 py-0" cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleRepairBreakdown' }" title="Vehicle Repair BreakDown Details">
          <clickable-card  icon="mdi-garage" color="accent" cardTitle="Vehicle Repair"> </clickable-card>
        </router-link>
      </v-col>

      <v-col  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleFitness' }" title="Vehicle Fitness Details">
          <clickable-card  icon="mdi-car-cog" color="accent" cardTitle="Vehicle Fitness"> </clickable-card>
        </router-link>
      </v-col>

      <v-col  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehiclePollution' }" title="Vehicle Pollution Details">
          <clickable-card  icon="mdi-mixcloud" color="accent" cardTitle="Vehicle Pollution"> </clickable-card>
        </router-link>
      </v-col>

      <v-col   cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleMaintenance' }" title="Vehicle Maintenance Details">
          <clickable-card  icon="mdi-cogs" color="info" cardTitle="Vehicle Maintenance"> </clickable-card>
        </router-link>
      </v-col>
      <v-col  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleFuleDetails' }" title="Vehicle Fuel Details">
          <clickable-card  icon="mdi-gas-station" color="green" cardTitle="Vehicle Fuel"> </clickable-card>
        </router-link>
      </v-col>
      <v-col  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleLoanDetails' }" title="Vehicle Loan Details">
          <clickable-card  icon="mdi-cash-100" color="orange" cardTitle="Vehicle Loan"> </clickable-card>
        </router-link>
      </v-col>
      <v-col  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleRoadTax' }" title="Vehicle Road Tax Details">
          <clickable-card  icon="mdi-currency-inr" color="Black" cardTitle="Vehicle Road Tax"> </clickable-card>
        </router-link>
      </v-col>
       <v-col  cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'vehicleChallan' }" title="Vehicle Challan Details">
          <clickable-card  icon="mdi-collage" color="red" cardTitle="Vehicle Challan"> </clickable-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
  </material-card>
</template>

<script>
import ClickableCard from '@/components/template/ClickableCard'
import MaterialCard from '@/components/template/MaterialCard'
export default {
  components: { ClickableCard, MaterialCard },
  name: 'vehicleSetting',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
